import { Fragment, PureComponent, ReactNode } from 'react';
import DentalExamination from './DentalExamination';
import DentalProcedure from './DentalProcedure';

export type ChartType = 'adult' | 'pedia' | 'mixed' | '';
export enum ChartTypeEnum {
    ADULT = 'adult',
    PEDIA = 'pedia',
    MIXED = 'mixed',
}

class DentalChart extends PureComponent {
    render(): ReactNode {
        return (
            <Fragment>
                <DentalExamination />
                <div className="bg-white px-16 pb-4">
                    <p className="h-1 bg-darwin-neutral-100"></p>
                </div>
                <DentalProcedure />
            </Fragment>
        );
    }
}

export default DentalChart;
